import { z } from 'zod'

import { LocalizedStringSchema } from '../common.schema'

const OfferSchema = z.object({
  offer_valid_until: z.string().optional().nullable(),
  amount: z.number().nullable(),
  offer_validity: z.string().optional().nullable()
})

const AddonSchema = z.object({
  visibility: z.number().optional(),
  _id: z.string(),
  name: LocalizedStringSchema,
  price: z.number(),
  addon_name_i18n: LocalizedStringSchema.optional()
})

const SubPackSchema = z.object({
  visibility: z.number(),
  price: z.number(),
  _id: z.string(),
  name: LocalizedStringSchema,
  sub_pack_name_i18n: LocalizedStringSchema.optional()
})

const TypePackSchema = z.object({
  _id: z.string(),
  t_name: LocalizedStringSchema.optional(),
  t_description: z.string().optional(),
  t_type: z.string(),
  t_sub_pack: z.array(SubPackSchema).optional(),
  type_name_i18n: LocalizedStringSchema.optional(),
  type_description_i18n: LocalizedStringSchema.optional()
})

const BasePackSchema = z.object({
  minTop: z.number().optional(),
  maxTop: z.number().optional(),
  _id: z.string(),
  name: LocalizedStringSchema.optional(),
  description: z.string(),
  type: z.string(),
  sub_pack: z.array(SubPackSchema),
  base_pack_name_i18n: LocalizedStringSchema.optional(),
  base_pack_description_i18n: LocalizedStringSchema.optional()
})

const ApiMenuItemSchema = z.object({
  _id: z.string(),
  name: LocalizedStringSchema,
  price: z.number(),
  description: z.string().optional(),
  isVisible: z.boolean(),
  maxOrderQuantity: z.number(),
  avatar: z.string(),
  isInReview: z.boolean(),
  addons: z.array(AddonSchema),
  type_pack: z.array(TypePackSchema),
  base_pack: z.array(BasePackSchema),
  offer: OfferSchema.optional(),
  invisibleUntil: z.number().optional()
})

const MenuSubCategorySchema = z.object({
  _id: z.string(),
  name: LocalizedStringSchema,
  items: z.array(ApiMenuItemSchema)
})

const MenuMainCategorySchema = z.object({
  _id: z.string(),
  name: LocalizedStringSchema,
  subCategories: z.array(MenuSubCategorySchema),
  subCategotiesExist: z.boolean(),
  items: z.array(ApiMenuItemSchema)
})

const ApiFetchMenuSchema = z.object({
  menu: z.object({
    mainCategories: z.array(MenuMainCategorySchema)
  })
})

export {
  ApiFetchMenuSchema,
  ApiMenuItemSchema,
  MenuMainCategorySchema,
  MenuSubCategorySchema
}
